import React from "react";
import TournamentCard from "./TournamentCard";
import PromoSpinnerBanner from "../common/PromoSpinnerBanner";

const TournamentList = ({ title, tournaments, onPlayNow, variant = "cash", spinnerPromoShown = false }) => {
  return (
    <>
      {tournaments?.length > 0 && (
        <div className="mb-4">
          {title && (
            <div className="flex items-center gap-4 mb-6">
              <div className="h-[1px] flex-grow bg-[var(--text-dark)]"></div>
              <h3 className="text-[12px] font-semibold text-lightGray uppercase whitespace-nowrap">
                {title}
              </h3>
              <div className="h-[1px] flex-grow bg-[var(--text-dark)]"></div>
            </div>
          )}
          {
            spinnerPromoShown && (
              <div className="mb-4">
                <PromoSpinnerBanner
                  leftImage={'/assets/images/games/leftimage.png'}
                  rightImage={'/assets/images/games/rightimage.png'}
                  title="WIN FREE TICKETS DAILY"
                />
              </div>
            )
          }
          <div className="flex flex-col">
            {tournaments.map((tournament, index) => (
              <TournamentCard
                key={index}
                tournament={tournament}
                variant={variant}
                onPlayNow={() => onPlayNow(tournament)}
              />
            ))}
          </div>
        </div>
      )}
    </>
  );
};

export default TournamentList;
